export default function (userData) {
    const mobileNumber = userData.mobileNumber;
    const brand = process.env.VUE_APP_BRAND;

    if (!mobileNumber) return "";

    let cleanedNumber = mobileNumber.replace(/\D/g, ""); // Remove non-numeric characters

    if (brand === "LOCUMATE" || brand === "HEYLUCY") {
        // Convert AU numbers to +61 format
        if (/^04\d{8}$/.test(cleanedNumber)) {
            return `+61${cleanedNumber.slice(1)}`;
        }
        if (/^61\d{9}$/.test(cleanedNumber)) {
            return `+${cleanedNumber}`;
        }
    }

    if (brand === "HEALTHSHIFTS") {
        // Convert US numbers to +1 format
        if (/^1\d{10}$/.test(cleanedNumber)) {
            return `+${cleanedNumber}`;
        }
        if (/^\d{10}$/.test(cleanedNumber)) {
            return `+1${cleanedNumber}`;
        }
    }

    return ""; // Return empty string if invalid
}
